import { connect } from 'react-redux'
import Header from './Header'

import selectIsFiltered from './Selectors/selectIsFiltered'

import onChangeSearch from './Handlers/onChangeSearch'
import onSearch from './Handlers/onSearch'
import onChangeFilter from './Handlers/onChangeFilter'

const mapStateToProps = (state) => ({
  search: state.screens.SubcontractorSubOrders.search,
  filters: state.screens.SubcontractorSubOrders.filters,
  isFiltered: selectIsFiltered(state),
})

const actionCreators = {
  onChangeSearch,
  onSearch,
  onChangeFilter,
}

export default connect(mapStateToProps, actionCreators)(Header)
